import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Dropdown, Table } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';

function StaffDemandReport() {
    const [carePlans, setCarePlans] = useState([]);
    const [totalsPerCustomer, setTotalsPerCustomer] = useState([]);

    useEffect(() => {
        const fetchCarePlans = async () => {
            try {
                const response = await fetch(`https://marzdev.yourcrm.co.za/api/careplans/all`);
                if (response.ok) {
                    const data = await response.json();
                    setCarePlans(data);
                    const allLineItems = data.flatMap(carePlan =>
                        carePlan.lineItems.map(lineItem => ({
                            ...lineItem,
                            CustomerName: carePlan.CustomerName
                        }))
                    );
                    const customerTotals = calculateTotalsPerCustomer(allLineItems);
                    setTotalsPerCustomer(customerTotals);
                } else {
                    console.error('Failed to fetch care plans');
                }
            } catch (error) {
                console.error('An error occurred while fetching the care plans:', error);
            }
        };

        fetchCarePlans();
    }, []);

    const calculateTotalsPerCustomer = (lineItems) => {
        const totalsMap = {};

        lineItems.forEach((item) => {
            const customerName = item.CustomerName;
            const multiplier = parseFloat(item.Multiplier) || 1;

            if (!totalsMap[customerName]) {
                totalsMap[customerName] = {
                    CustomerName: customerName,
                    SN_HoursDay: 0,
                    SN_HoursNight: 0,
                    ENA_HoursDay: 0,
                    ENA_HoursNight: 0,
                    CW_HoursDay: 0,
                    CW_HoursNight: 0,
                };
            }

            totalsMap[customerName].SN_HoursDay += (parseFloat(item.SN_HoursDay) * multiplier);
            totalsMap[customerName].SN_HoursNight += (parseFloat(item.SN_HoursNight) * multiplier);
            totalsMap[customerName].ENA_HoursDay += (parseFloat(item.ENA_HoursDay) * multiplier);
            totalsMap[customerName].ENA_HoursNight += (parseFloat(item.ENA_HoursNight) * multiplier);
            totalsMap[customerName].CW_HoursDay += (parseFloat(item.CW_HoursDay) * multiplier);
            totalsMap[customerName].CW_HoursNight += (parseFloat(item.CW_HoursNight) * multiplier);
        });

        return Object.values(totalsMap);
    };


    return (
        <div>

            <div className="container mt-4">
                <p>Summary of Staff Demand per care recipient</p>
                <div className='table-wrapper mb-4' >
                    <Table className='mb-0'>
                        <tr>
                            <th colSpan="8" style={{ textAlign: 'center' }}>
                                <strong>Summary Tabulated</strong>
                            </th>

                        </tr>
                        <tr>
                            <td colSpan="2"><strong>Customer demand on staff</strong></td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.SN_HoursDay, 0)) / 8 / 12).toFixed(2)}</td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.SN_HoursNight, 0)) / 8 / 12).toFixed(2)}</td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.ENA_HoursDay, 0)) / 8 / 12).toFixed(2)}</td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.ENA_HoursNight, 0)) / 8 / 12).toFixed(2)}</td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.CW_HoursDay, 0)) / 8 / 12).toFixed(2)}</td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.CW_HoursNight, 0)) / 8 / 12).toFixed(2)}</td>
                        </tr>

                        <tr>
                            <td colSpan="2"><strong>Statutory modifier (meals, tea)</strong></td>
                            <td>{88}%</td>
                            <td>{88}%</td>
                            <td>{88}%</td>
                            <td>{88}%</td>
                            <td>{88}%</td>
                            <td>{88}%</td>
                        </tr>

                        <tr>
                            <td colSpan="2"><strong>Admin modifier</strong></td>
                            <td>{82}%</td>
                            <td>{82}%</td>
                            <td>{82}%</td>
                            <td>{82}%</td>
                            <td>{99}%</td>
                            <td>{99}%</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>Efficiency modifier</strong></td>
                            <td>{85}%</td>
                            <td>{85}%</td>
                            <td>{85}%</td>
                            <td>{85}%</td>
                            <td>{85}%</td>
                            <td>{85}%</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>Calculated Total minimum staff required</strong></td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.SN_HoursDay, 0)) / 8 / 12 / 0.88 / 0.82 / 0.85).toFixed(2)}</td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.SN_HoursNight, 0)) / 8 / 12 / 0.88 / 0.82 / 0.85).toFixed(2)}</td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.ENA_HoursDay, 0)) / 8 / 12 / 0.88 / 0.82 / 0.85).toFixed(2)}</td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.ENA_HoursNight, 0)) / 8 / 12 / 0.88 / 0.82 / 0.85).toFixed(2)}</td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.CW_HoursDay, 0)) / 8 / 12 / 0.88 / 0.99 / 0.85).toFixed(2)}</td>
                            <td>{((totalsPerCustomer.reduce((sum, curr) => sum + curr.CW_HoursNight, 0)) / 8 / 12 / 0.88 / 0.99 / 0.85).toFixed(2)}</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>Basic Minimum Labour check</strong></td>
                            <td>{1.00}</td>
                            <td>{1.00}</td>
                            <td>{2.00}</td>
                            <td>{2.00}</td>
                            <td>{4.00}</td>
                            <td>{4.00}</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>Total minimum staff actually required</strong></td>
                            <td>
                                {Math.max(
                                    Math.ceil(totalsPerCustomer.reduce((sum, curr) => sum + curr.SN_HoursDay, 0) / 8 / 12 / 0.88 / 0.82 / 0.85),
                                    1 // Basic Minimum Labour check for SN_HoursDay
                                )}
                            </td>
                            <td>
                                {Math.max(
                                    Math.ceil(totalsPerCustomer.reduce((sum, curr) => sum + curr.SN_HoursNight, 0) / 8 / 12 / 0.88 / 0.82 / 0.85),
                                    1 // Basic Minimum Labour check for SN_HoursNight
                                )}
                            </td>
                            <td>
                                {Math.max(
                                    Math.ceil(totalsPerCustomer.reduce((sum, curr) => sum + curr.ENA_HoursDay, 0) / 8 / 12 / 0.88 / 0.82 / 0.85),
                                    2 // Basic Minimum Labour check for ENA_HoursDay
                                )}
                            </td>
                            <td>
                                {Math.max(
                                    Math.ceil(totalsPerCustomer.reduce((sum, curr) => sum + curr.ENA_HoursNight, 0) / 8 / 12 / 0.88 / 0.82 / 0.85),
                                    2 // Basic Minimum Labour check for ENA_HoursNight
                                )}
                            </td>
                            <td>
                                {Math.max(
                                    Math.ceil(totalsPerCustomer.reduce((sum, curr) => sum + curr.CW_HoursDay, 0) / 8 / 12 / 0.88 / 0.99 / 0.85),
                                    4 // Basic Minimum Labour check for CW_HoursDay
                                )}
                            </td>
                            <td>
                                {Math.max(
                                    Math.ceil(totalsPerCustomer.reduce((sum, curr) => sum + curr.CW_HoursNight, 0) / 8 / 12 / 0.88 / 0.99 / 0.85),
                                    4 // Basic Minimum Labour check for CW_HoursNight
                                )}
                            </td>
                        </tr>
                    </Table>
                </div>
                <div className='table-wrapper'>
                    <Table striped bordered hover className="">
                    <thead>
                            <tr>
                                <th>No.</th>
                                <th>Care Recipient</th>
                                <th colSpan={2}>SN Hours </th>
                                <th colSpan={2}>ENA Hours </th>
                                <th colSpan={2}>CW Hours </th>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th style={{ top: 39 }}></th>
                                <th style={{ top: 39 }}></th>
                                <th style={{ top: 39 }}>Day</th>
                                <th style={{ top: 39 }}>Night</th>
                                <th style={{ top: 39 }}>Day</th>
                                <th style={{ top: 39 }}>Night</th>
                                <th style={{ top: 39 }}>Day</th>
                                <th style={{ top: 39 }}>Night</th>
                            </tr>
                        </thead>
                        <tbody>
                            {totalsPerCustomer.map((totals, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{totals.CustomerName}</td>
                                    <td>{totals.SN_HoursDay.toFixed(2)}</td>
                                    <td>{totals.SN_HoursNight.toFixed(2)}</td>
                                    <td>{totals.ENA_HoursDay.toFixed(2)}</td>
                                    <td>{totals.ENA_HoursNight.toFixed(2)}</td>
                                    <td>{totals.CW_HoursDay.toFixed(2)}</td>
                                    <td>{totals.CW_HoursNight.toFixed(2)}</td>
                                </tr>

                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );
}

export default StaffDemandReport;
